module.exports = __webpack_public_path__ + "img/mood.fee3faf7.jpg";